<template>
  <div class="wx-page2" >
    <div v-if="goodsInfo">
      <div class="goods-info-inner">


        <div class="goods-img-wrapper">
          <img
            :src="image" v-for="(image,index) in goodsInfo.images" :key="index"
            class="goods-img"/>
        </div>
<!--        <div class="desc" v-html="goodsInfo.goodsIntroduction">-->
<!--        </div>-->


      </div>

      <div class="order-now-wrapper">
        <div class="title">
          <div class="productName">{{ goodsInfo.goodsName }}</div>
          <div class="price">
            <FancyDecimal :value="lowestPrice" class="fancyDecimal"></FancyDecimal>
            <span class="price-title price-unit price-start-from" v-if="this.goodsInfo.goodsSkuInfo?.length>1">起</span>
          </div>
        </div>
        <div class="btn-wrapper">

          <!-- <div class="order" v-if="goodsInfo.tryType == 1" @click="toApproval">预约试用</div> -->
          <!-- <div class="cost" @click="toPurchase">立即购买</div> -->
<!--          <div class="cost2 toTest" @click.stop="toTest" v-if="goodsInfo.times>0">-->
<!--            <p>立即检测</p>-->
<!--            <p class="times">({{ goodsInfo.times }}次)</p>-->
<!--          </div>-->
          <div class="cost2" @click.stop="toPurchase">{{lowestPrice?'立即购买':'免费领取'}}</div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {formatToDecimal} from "../../utils/format";
import {goToTest, loginCheck} from "@/utils/help";
import {getGoodsDetail, getNavigationData} from "@/api/api";
import FancyDecimal from "@/components/FancyDecimal.vue";

export default {
  metaInfo: {
    title: "商品详情",
  },
  props: {
    goodsId:[String,Number]
  },
  components: {FancyDecimal},
  data() {
    return {
      goodsInfo: null,
      goodsList:[]
    };
  },

  async mounted() {
    await this.init();

  },
  computed:{
    lowestPrice(){
      if (this.goodsInfo==null){
        return 0
      }
      const pricesList = this.goodsInfo.goodsSkuInfo.map(item=>{
        console.log(item)
        if(item.singleFreeNumber>0){
          return 0
        }else{
          return item.price
        }
      })
      return Math.min(...pricesList)
    }
  },

  methods: {
    formatToDecimal,
    async init() {
      await this.loadGoodsDetail()
    },
    async toPurchase(){
      const isLogined = await loginCheck()
      if (isLogined){
        this.$router.push({
          name:'wx-placeOrder',
          params: {
            goodsId:this.goodsId,

          },
        });
      }

    },
    toTest(){
      //goToTest()
    },
    async loadGoodsDetail(){
      const res  = await getGoodsDetail({goodsId:this.goodsId})
      this.goodsInfo = res.data
    }


  },
};
</script>
<style lang="stylus" scoped>
.wx-page2 {
  background #fff;
  padding-bottom 0rem
  min-height auto

  .section-nav{
    padding-top .1rem
    margin-bottom: .20rem;
    padding-left .2rem;
    padding-right .2rem
    padding-bottom:0rem;
    display: flex;
    overflow: auto;

    a.section-nav-item{
      flex-shrink: 0;
      background-color: #F4F6F8;
      border: 2px solid #F4F6F8;
      margin-right: .16rem;
      border-radius: .12rem;
      padding: .11rem;
      min-width: 1.44rem;
      text-align: center;
      font-size: .24rem;
      color #000
    }
    a.section-nav-item.active{
      border:1px solid #165DFF;
      font-weight: 600;
      color: #165DFF ;
    }
  }

  .section-nav {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox, Safari 18.2+, Chromium 121+ */
  }
  .section-nav::-webkit-scrollbar {
    display: none;  /* Older Safari and Chromium */
  }

  .goods-list{

  }

  .goods-info-inner {
    padding 0 0.2rem

    .goods-img-wrapper {

      .goods-img {
        width: 7.10rem
        border-radius: 0.16rem;
        margin-bottom .2rem
      }


    }
    .desc {
      color: #242424;
      font-weight: 400;
      font-size: .28rem;
    }


  }

  .order-now-wrapper {
    padding-bottom: calc(constant(safe-area-inset-bottom)  + .5rem); /*兼容 IOS<11.2*/
    padding-bottom: calc(env(safe-area-inset-bottom) + .5rem); /*兼容 IOS>11.2*/

    box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.08);
    position fixed;
    bottom 0;
    z-index 1;
    width: 100%;
    // height: 2.5rem;
    background: #FFFFFF;
    border-radius: 0.24rem 0.24rem 0 0;
    opacity: 1;
    font-size: 0.3rem;
    color: #0E1429;
    box-sizing: border-box;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1.07rem;
      padding: 0 0.3rem;
      height: 1.07rem;

      .productName {
        width 4.8rem
        font-size: 0.3rem;
        line-height 1.5
        color: #1D2129;
        font-weight: 600;
      }

      .price {
        color: #165DFF;
        display flex
        :deep(.fancyDecimal){
          line-height: normal;
          font-family: DIN Alternate-Bold, DIN Alternate;
          .unit{
            font-size: 0.3rem;
          }

          .integer{
            font-size: 0.48rem;
          }
          .fragment{
            font-size: 0.3rem;
          }
        }

        .symbol{
          font-size: .3rem;
          position relative;
          top: 0.05rem;
        }


        .price-title {
          font-family: DIN Alternate-Bold, DIN Alternate;
          font-size: 0.48rem;
          color: #165DFF;
          font-weight: bold;

          &.price-unit {
            font-size: 0.3rem;
            font-weight: normal;
          }
        }
        .price-start-from{
          margin-left .05rem
          line-height normal
          position relative;
          top: 0.11rem;
        }
      }
    }

    .btn-wrapper {
      display: flex;
      //align-items: center;
      //margin: 0.16rem 0;
      height: 1.12rem;
      padding: 0.16rem 0.3rem;
      justify-content: space-between;
      box-sizing: border-box;

      .my {
        text-align: center;
        font-size: 0.22rem;
        color: #165DFF;
        //margin: 0 0.65rem;
        margin-left: 0.3rem;

        .el-icon-user {
          margin-bottom: 0.1rem;
        }

        .icon-wode {
          font-size: 0.36rem;
          color: #1D2129;
        }

        .icon-icon_wode {
          font-size: 0.36rem;
          color: #1D2129;
        }
      }

      .order, .cost {
        width: 2.58rem;
        height: 0.8rem;
        line-height: 0.8rem;
        background: rgba(63, 116, 246, 0.2);
        border-radius: 0.1rem;
        color: #3F74F6;
        font-size: 0.32rem;
        text-align: center;
      }

      .cost {
        margin-left: 0.3rem;
        background: #3F74F6;
        opacity: 1;
        color: #fff;
      }

      .cost2 {
        width: 4.14rem;
        flex-grow 1;
        height: 0.8rem;
        line-height: 0.8rem;
        background: #165DFF;
        opacity: 1;
        color: #fff;
        font-size: 0.32rem;
        text-align: center;
        font-weight: 400;
        border-radius: 0.1rem;
      }

      .cost2.toTest {
        width 2.56rem
        margin-right 0.2rem
        line-height: 0.05;
        background: transparent;
        border: 1px solid #165DFF;
        color: #165DFF;

        > .times {
          font-size: 10px;
          color: #A4A6A9
        }
      }
    }
  }
}

</style>
